var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"box"}},[_c('Icon',{staticClass:"com-hand",class:[{left:_vm.menuType}],attrs:{"size":_vm.iconSize,"type":"md-arrow-dropleft"},on:{"click":_vm.LAYOUT_CHANGE}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }